import React, { Component } from "react";
import { Title } from "components/misc";
import { Container } from 'design-react-kit';
import { withRouter } from 'react-router-dom';
import { AdminLessonOnSiteScheduleForm } from "components/forms/admin/AdminLessonOnSiteScheduleForm";


class LessonOnSiteScheduleForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
        idLessonOnSiteSchedule: parseInt(this.props.match.params.idLessonOnSiteSchedule) > 0 ? this.props.match.params.idLessonOnSiteSchedule : 0
    }
  }

  render() {
    const { idLessonOnSiteSchedule } = this.state

    return (
      <>
        <section className="my-4">
          <Container>
            <Title>{(idLessonOnSiteSchedule > 0) ? 'Aggiorna Lezione in Presenza' : 'Crea Lezione in Presenza'}</Title>
            {<AdminLessonOnSiteScheduleForm idLessonOnSiteSchedule={idLessonOnSiteSchedule || 0}/>}
          </Container>
        </section>
      </>
    );
  }

}

export default withRouter(LessonOnSiteScheduleForm);
